import{useEffect as e}from"react";const t=t=>{e((()=>{const e=e=>{"Escape"===e.key&&t()};return document.addEventListener("keydown",e),()=>{document.removeEventListener("keydown",e)}}),[t])};export{t as default,t as useEscapeKeydown};
